<div class="row" *ngIf="!disabled" [ngClass]="{'hidden': hideUploader}">
  <div class="col-4 dropzone" [ngxFileDropzone]="readMode" (fileDrop)="dropFile($event)">Drop a file in this zone.</div>
  <div class="col-2 btnzone"><button type="button" id="btn_upload" onclick="document.getElementById('file').click();"
      class="btn btn-info">CARICA ALLEGATO...</button></div>
</div>

<button mat-button *ngIf="showFotoVetrina" type="button" value="Foto vetrina" (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)" (click)="tab = 'slideshow'"
  [ngClass]="{'btn': true, 'btn-success': tab=='slideshow',   'btn-default': tab!='slideshow' }">
  <i class="material-icons">slideshow</i>
</button>

<button mat-button *ngIf="showFotoVetrina" type="button" value="Foto vetrina" (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)" (click)="tab = 'foto_vetrina'"
  [ngClass]="{'btn': true, 'btn-success': tab=='foto_vetrina',   'btn-default': tab!='foto_vetrina' }">
  <i class="material-icons">directions_car</i>
</button>

<button mat-button *ngIf="showAltriElementi" type="button" value="Altri elementi" (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)" (click)="tab = 'altri_elementi'"
  [ngClass]="{'btn': true, 'btn-success': tab=='altri_elementi', 'btn-default': tab!='altri_elementi' }">
  <i class="material-icons">insert_photo</i>
</button>

<button mat-button *ngIf="img_360" type="button" value="360°" (click)="this.tab = '360';"
  (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='360', 'btn-default': tab!='360' }">
  <i class="material-icons">360</i>
</button>

<button mat-button *ngIf="source?.result?.damages && source?.result?.damages?.length > 0" type="button" value="Danni"
  (click)="tab = 'danni'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='danni', 'btn-default': tab!='danni' }">
  <i class="material-icons">sentiment_very_dissatisfied</i>
</button>

<button mat-button *ngIf="source?.result?.damagesInt && source?.result?.damagesInt?.length > 0" type="button"
  value="Altre parti danneggiate" (click)="tab = 'danniInt'" (mouseenter)="mouseEnter($event)"
  (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='danniInt', 'btn-default': tab!='danniInt' }">
  <i class="material-icons">disabled_by_default</i>
</button>

<!--
<button mat-button *ngIf="source?.result?.damages && source?.result?.damages?.length > 0 " type="button" value="Danni" (click)="tab = 'riparazioni'"
  (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='riparazioni', 'btn-default': tab!='danni' }">
  <i class="material-icons">settings_ethernet</i>
</button>
-->
<button mat-button *ngIf="source?.result?.attachments && source?.result?.attachments?.length > 0" type="button"
  value="foto libere" (click)="tab = 'camera'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='camera', 'btn-default': tab!='camera' }">
  <i class="material-icons">camera_alt</i>
</button>

<button mat-button *ngIf="source?.result?.glasses && source?.result?.glasses.length>0" type="button" value="Cristalli"
  (click)="tab = 'cristalli'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='cristalli', 'btn-default': tab!='cristalli' }">
  <i class="material-icons">broken_image</i>
</button>


<button mat-button *ngIf="source?.result?.documenti && source?.result?.documenti.length>0" type="button"
  value="Documenti" (click)="tab = 'documenti'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='documenti', 'btn-default': tab!='documenti' }">
  <i class="material-icons">folder</i>
</button>

<button mat-button *ngIf="source?.allegati && source?.allegati.length>0" type="button" value="Altri file"
  (click)="tab = 'altri_file'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='altri_file', 'btn-default': tab!='altri_file' }">
  <i class="material-icons">attach_file</i>
</button>

<button mat-button *ngIf="source?.result?.tiresData && isTiresDataPresent()" type="button" value="Ruote"
  (click)="tab = 'tires'" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='tires', 'btn-default': tab!='tires' }">
  <i class="material-icons">album</i>
</button>

<button mat-button *ngIf="source?.result?.geo" type="button" value="Geo" (click)="loadMapTab()"
  (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='geo', 'btn-default': tab!='geo' }">
  <i class="material-icons">place</i>
</button>

<button mat-button *ngIf="source?.result?.archiveList?.length>0" type="button" value="Geo" (click)="tab = 'archiveList'"
  (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
  [ngClass]="{'btn': true, 'btn-success': tab=='archiveList', 'btn-default': tab!='archiveList' }">
  <i class="material-icons">videocam</i>
</button>


{{tab_hover}}


<div class="row" *ngIf="tab=='slideshow'">
  <app-sliedeshow [images]="source?.result?.fotoVetrina | presentImage"></app-sliedeshow>
</div>


<div *ngIf="tab=='foto_vetrina'" style="height:100%">


  <table style="height:100%">


    <tr>
      <td style="width:33%">
        <div class="growx" *ngIf="!source?.result?.fotoVetrina[5].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(5)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,5)">
            <img
              [src]="source?.result?.fotoVetrina[5].url ? source?.result?.fotoVetrina[5].url : source?.result?.fotoVetrina[5].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[5].url.includes('null')">&nbsp;</div>
      </td>
      <td style="width:33%">
        <div class=" growx" *ngIf="!source?.result?.fotoVetrina[6].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(6)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,6)">
            <img
              [src]="source?.result?.fotoVetrina[6].url ? source?.result?.fotoVetrina[6].url : source?.result?.fotoVetrina[6].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[6].url.includes('null')">&nbsp;</div>
      </td>
      <td style="width:33%">
        <div class="growx" *ngIf="!source?.result?.fotoVetrina[7].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(7)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,7)">
            <img
              [src]="source?.result?.fotoVetrina[7].url ? source?.result?.fotoVetrina[7].url : source?.result?.fotoVetrina[7].thumb"
              class="halfwidth">
          </a>
        </div>
      </td>
    </tr>


    <tr>
      <td>
        <div class=" growx" *ngIf="!source?.result?.fotoVetrina[4].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(4)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,4)">
            <img
              [src]="source?.result?.fotoVetrina[4].url ? source?.result?.fotoVetrina[4].url : source?.result?.fotoVetrina[4].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[4].url.includes('null')">&nbsp;</div>
      </td>
      <td>
        <div>
          <img [src]="'./assets/img/center/center_'+source?.result?.vehType+'.png'" class="halfwidth">
        </div>
      </td>
      <td>
        <div class="growx" *ngIf="!source?.result?.fotoVetrina[0].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(0)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,0)">
            <img
              [src]="source?.result?.fotoVetrina[0].url ? source?.result?.fotoVetrina[0].url : source?.result?.fotoVetrina[0].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[0].url.includes('null')">&nbsp;</div>
      </td>
    </tr>


    <tr>
      <td>
        <div class=" growx" *ngIf="!source?.result?.fotoVetrina[3].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(3)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,3)">
            <img
              [src]="source?.result?.fotoVetrina[3].url ? source?.result?.fotoVetrina[3].url : source?.result?.fotoVetrina[3].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[3].url.includes('null')">&nbsp;</div>
      </td>
      <td>
        <div class="growx" *ngIf="!source?.result?.fotoVetrina[2].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(2)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,2)">
            <img
              [src]="source?.result?.fotoVetrina[2].url ? source?.result?.fotoVetrina[2].url : source?.result?.fotoVetrina[2].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[2].url.includes('null')">&nbsp;</div>
      </td>
      <td>
        <div class="growx" *ngIf="!source?.result?.fotoVetrina[1].url.includes('null')">

          <button type="button" color="warn" mat-icon-button *ngIf="!disabled" (click)="deleteFotoVetrina(1)"
            style="position:absolute; top:0; right:20px;"><i class="material-icons">delete_forever</i></button>

          <a class="halfwidth" (click)="openFile(source.result.fotoVetrina,1)">
            <img
              [src]="source?.result?.fotoVetrina[1].url ? source?.result?.fotoVetrina[1].url : source?.result?.fotoVetrina[1].thumb"
              class="halfwidth">
          </a>
        </div>
        <div *ngIf="source?.result?.fotoVetrina[1].url.includes('null')">&nbsp;</div>
      </td>
    </tr>


  </table>



  <mat-slide-toggle [(checked)]="blur" (change)="changeBlur($event)">Abilita mascheramento sfondo!</mat-slide-toggle>
  <br>
  <div *ngIf="blur">
    <hr>
    <table>
      <tr>
        <td>ScaleMask (%):</td>
        <td><input type="number" [(ngModel)]="blurOptions.scaleMask"></td>


        <td>blurMask (%):</td>
        <td><input type="number" [(ngModel)]="blurOptions.blurMask"></td>
      </tr>

      <tr>
        <td>BlurOpacity (px):</td>
        <td><input type="number" [(ngModel)]="blurOptions.blurOpacity"></td>


        <td>BlurQuantity (px):</td>
        <td><input type="number" [(ngModel)]="blurOptions.blurQuantity"></td>
      </tr>

      <tr colspan=4>
        <button mat-button calss="btn btn-warning" (click)="refreshBlur()">Refresh!</button>
      </tr>
    </table>
  </div>


  <!--
  <div class="col-12 col-sm-3  bshadow growx" *ngFor="let a of source.result.fotoVetrina ; index as i " style="margin:0;padding:0;">

    <a class="halfwidth" (click)="openFile(i)">
      <img [src]="a.url ? a.url : a.thumb" class="halfwidth">
    </a>

    <div class="img-footer" (click)="openFile(i)" *ngIf="a.fileName">
      {{ a.fileName }} - {{humanize(a.size)}}
    </div>

  </div>
  -->
</div>

<div class="row" *ngIf="tab=='altri_elementi'">

  <!--
  <div class="col" class="col-12 col-sm-3">
    <img [src]="'./assets/img/altri_elementi/altri_elementi_' + source.result.vehType + '.png'" class="halfwidth">
  </div>
  -->

  <div class="col">


    <div class="row">
      <div class="col-12 col-sm-6 col-md-3 bshadow growx" *ngFor="let a of source.result.altriElementi ; index as i "
        style="margin:0">



        <button type="button" color="warn" mat-icon-button (click)="deleteAltriElementi(i)"
          *ngIf="!a.url?.includes('null') && !disabled" style="position:absolute; top:0; right:20px;"><i
            class="material-icons">delete_forever</i></button>

        <a class="halfwidth" (click)="openFile(source.result.altriElementi,i)" *ngIf="!a.url?.includes('null')">
          <img [src]="a.url ? a.url : a.thumb" class="halfwidth">
        </a>

        <div class="img-footer" (click)="openFile(i)" *ngIf="a.fileName">
          {{ a.fileName }} - {{humanize(a.size)}}
        </div>

        <div class="img-footer" (click)="openFile(i)" *ngIf="a.label" style="padding-left:10px">
          {{(i+1)}} - {{ a.label }}
        </div>
      </div>
    </div>
  </div>

</div>

<div *ngIf="tab=='cristalli'">

  <div *ngFor="let a of source.result.glasses; index as i">
    <h3>{{getGlassName(a.id)}}</h3>
    <div class="row">

      <div class="col-4 ">
        <a class="halfwidth">
          <img [src]="'/assets/img/glasses/cristalli_' + a.id + '.png'" class="halfwidth">
        </a>
      </div>

      <div class="col-4 ">
        <a class="halfwidth" (click)="openGlass(a)">
          <img [src]="a.img1.url ? a.img1.url : a.img1.thumb" class="halfwidth">
        </a>
      </div>

      <div class="col-4 ">
        <a class="halfwidth" (click)="openGlass(a)">
          <img [src]="a.img2.url ? a.img2.url : a.img2.thumb" class="halfwidth">
        </a>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="tab=='documenti'">

  <div class="col-12 col-sm-6 col-md-3 bshadow growx" *ngFor="let a of source.result.documenti; index as i ">

    <button type="button" color="warn" mat-icon-button (click)="deleteDocumenti(i)"
      *ngIf="!a.url.includes('null') && !disabled" style="position:absolute; top:0; right:20px;"><i
        class="material-icons">delete_forever</i></button>

    <a class="halfwidth" (click)="openFile(source.result.documenti,i)">
      <img [src]="a.url ? a.url : a.thumb" class="halfwidth">
    </a>

    <div class="img-footer" *ngIf="a.fileName">
      {{ a.fileName }} - {{humanize(a.size)}}
    </div>

    <div class="img-footer" *ngIf="a.label" style="padding-left:10px">
      {{ a.label }}
    </div>

  </div>
</div>

<div class="row" *ngIf="tab=='altri_file'">

  <div style="height: 8vw" class="bshadow growx img-card"
    [ngClass]="{'col-1' : orderMode,      'col-12' : !orderMode,  'col-sm-6 ' : !orderMode,  'col-md-3' : !orderMode    }"
    *ngFor="let a of source.allegati | filterByFileType: ['img','pdf','oth', showPP ? 'pp' : 'xx'] ; index as i "
    style="margin-left:0;margin-right:0;" (dragover)="allowDrop($event)" (drop)="drop($event,i)">



    <button type="button" color="primary" mat-icon-button (click)="renameAllegati(a)"
      *ngIf="!a.url.includes('null') && !disabled && !orderMode"
      style="position:absolute; top:0; right:15px; background-color: white; border-radius: 50%;"><i
        class="material-icons">edit</i></button>

    <button type="button" color="warn" mat-icon-button (click)="deleteAllegati(a)"
      *ngIf="!a.url.includes('null') && !disabled && !orderMode"
      style="position:absolute; top:45px; right:15px; background-color: white; border-radius: 50%;"><i
        class="material-icons">delete_forever</i></button>

    <button type="button" [color]="a.hidden ? 'warn' : 'success'" mat-icon-button (click)="toggleVisibilityAllegati(a)"
      *ngIf="!a.url.includes('null') && !disabled && !orderMode"
      style="position:absolute; top:90px; right:15px; background-color: white; border-radius: 50%;"><i
        class="material-icons">{{a.hidden ? 'visibility_off' : 'visibility'}}</i></button>




    <img (click)="openFile(source.allegati,i)" [src]="isImage(a)" class="halfwidth" *ngIf="!orderMode"
      style="object-fit: cover; height: 100%; width:100%;">
    <img (click)="openFile(source.allegati,i)" [src]="isImage(a)" class="halfwidth" *ngIf="orderMode"
      [draggable]="orderMode" (dragstart)="drag($event,a)" style="object-fit: cover; height: 100%; width:100%;">




    <div class="img-footer" *ngIf="a.fileName">
      {{ a.fileName }} - {{humanize(a.size)}}
    </div>

    <div class="img-footer" *ngIf="a.label" style="padding-left:10px">
      {{ a.label }}
    </div>

  </div>


  <div style="height: 8vw; border: solid 1px gray; " class="col-1 bshadow growx img-card" *ngIf="orderMode"
    style="margin-left:0;margin-right:0;" (dragover)="allowDrop($event)" (drop)="drop($event,source.allegati.length)">



  </div>

</div>


<div class="row" *ngIf="tab=='danni'">
  <div class="col-12">
    <!--
    <app-blueprint [setValue]="source.result" [disabled]='true' (onSelected)=openFileEvent($event)
      style="max-width:75vw!important"></app-blueprint>-->

    <app-blueprint-3d *ngIf="source?.result?.damages && tab=='danni'" [showLoading]="true" [readonly]="true"
      [objUrl]="'/assets/models/audi.glb'" [damages]="source.result.damages" class="full damages" [hideList]="false">
    </app-blueprint-3d>
  </div>
</div>

<div class="row" *ngIf="tab=='danniInt'">

  <div class="col-12 col-sm-6 col-md-3 bshadow growx" *ngFor="let a of source.result.damagesInt; index as i ">

    <!--<button type="button" color="warn" mat-icon-button (click)="deleteDamagesInt(i)"
       style="position:absolute; top:0; right:20px;"><i
        class="material-icons">delete_forever</i></button>-->

    <a class="halfwidth" (click)="openFileDamageInt(source.result.damagesInt,i)">
      <img [src]="a.img1?.thumb" class="halfwidth">
    </a>



    <div class="img-footer" *ngIf="a.part">
      {{ a.part }}
    </div>

  </div>
</div>

<div class="row" *ngIf="tab=='riparazioni'">
  <div class="col-12" *ngIf="source?.result?.damages">

    <div *ngFor="let d of source.result.damages; index as i;">

      <div class="card">

        <div class="row">
          <div class="col-3">
            <img style="width:128px; display:block; margin:auto;" [src]="d.img2.thumb">
          </div>
          <div class="col-6">
            <p style="font-weight: bold; width:100%; text-align: center;">{{i+1}}.0 - </p>
          </div>
          <div class="col-3">
            <img style="width:128px; display:block; margin:auto;" *ngIf=" d?.img_rip" [src]=" d?.img_rip?.thumb">
          </div>
        </div>

      </div>

      <div *ngFor="let ed of d.extra; index as j;">
        <div class="card">

          <div class="row">
            <div class="col-3">
              <img style="width:128px; display:block; margin:auto;" [src]="ed.img2.thumb">
            </div>

            <div class="col-6">
              <p style="font-weight: bold; width:100%; text-align: center;">{{i+1}}.{{j+1}} - {{ed.descr}}</p>
            </div>

            <div class="col-3">
              <img style="width:128px; display:block; margin:auto;" *ngIf="ed?.img_rip" [src]="ed?.img_rip?.thumb">
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</div>

<div class="row" *ngIf="tab=='camera'">

  <div class="col-12 col-sm-6 col-md-3 bshadow growx" *ngFor="let a of source.result.attachments; index as i ">

    <button type="button" color="warn" mat-icon-button (click)="deleteAttachments(i)"
      *ngIf="!a.url.includes('null') && !disabled" style="position:absolute; top:0; right:20px;"><i
        class="material-icons">delete_forever</i></button>



    <a class="halfwidth" (click)="openFile(source.result.attachments,i)">
      <img [src]="a.url ? a.url : a.thumb" class="halfwidth">
    </a>

    <div class="img-footer" *ngIf="a.fileName">
      {{ a.fileName }} - {{humanize(a.size)}}
    </div>

  </div>
</div>

<div class="row" *ngIf="tab=='tires'">
  <app-tires *ngIf="source?.result?.tiresData" [(value)]="source.result.tiresData" (onChange)="tiresDataChanged()"
    (onOpenViewer)="openViewer($event)">
  </app-tires>
</div>

<div class="row" *ngIf="tab=='geo'" style=" padding:0; margin:0; height:50vh">
  <div class="col-12" style=" padding:0; margin:0; height:50vh">
    <div id="map" style=" padding:0; margin:0; height:50vh"></div>
  </div>
  <br>
  <p style="font-weight: bold;">
    Geolocalizzazione: {{this.source.result.geo.latitude }}, {{this.source.result.geo.longitude}}</p>

</div>

<div class="row" *ngIf="tab=='360'" style=" padding:0; margin:0; height:50vh">

  <app-c360 style="background-color: gray" style="width: 100%; height:50vh" [(setURL)]="img_360" *ngIf=" tab=='360'"
    [setImages]="source?.result?.altriElementi">
  </app-c360>

</div>

<div class="row" *ngIf="tab=='archiveList'" style=" padding:0; margin:0; height:50vh">

  <div class="row" *ngIf="source?.result?.archiveList?.length > 0" style="padding:15px">
    <div class="col" *ngFor="let v of source?.result?.archiveList; index as i">
      <img style="width:100%; cursor: pointer;" [src]="v.thumb" (click)="openVideo(v.id)">
    </div>
  </div>

</div>